angular.module( 'acme.view.application.programs.combos.create.description', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.combos.create.description.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsCombosCreateDescription = {
        name: 'application.programs.combos.create.description',
        url: '',
        views: {
          "subview-main": {
            controller: 'ProgramsCombosCreateDescriptionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/combos/create/description/description.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Combo Description'
        },
        resolve: {
          bootstrap: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/bootstrap.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernote: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/summernote.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernoteCss: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/summernote.css", 'summernote', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }]
        }
      },
      programsCombosEditDescription = {
        name: 'application.programs.combos.edit.description',
        url: '',
        views: {
          "subview-main": {
            controller: 'ProgramsCombosCreateDescriptionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/combos/create/description/description.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit Combo Description'
        },
        resolve: {
          bootstrap: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/bootstrap.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernote: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/summernote.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }],
          summernoteCss: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/summernote.css", 'summernote', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;

          }]
        }
      };

    $stateProvider
      .state(programsCombosCreateDescription)
      .state(programsCombosEditDescription);
});
